import React, { createContext, useContext, useEffect, useState, useMemo } from "react";

const ACCENTS = {
  blue:   { primary: "#2563EB", hover: "#1D4ED8", ring: "#3B82F6", soft: "#EFF6FF", deep: "#1E40AF" },
  green:  { primary: "#16A34A", hover: "#15803D", ring: "#22C55E", soft: "#F0FDF4", deep: "#14532D" },
  purple: { primary: "#7C3AED", hover: "#6D28D9", ring: "#8B5CF6", soft: "#F5F3FF", deep: "#4C1D95" },
  orange: { primary: "#EA580C", hover: "#C2410C", ring: "#F97316", soft: "#FFF7ED", deep: "#7C2D12" },
  slate:  { primary: "#475569", hover: "#334155", ring: "#64748B", soft: "#F1F5F9", deep: "#1E293B" },
  rose:   { primary: "#E11D48", hover: "#BE123C", ring: "#F43F5E", soft: "#FFF1F2", deep: "#881337" },
};

const ThemeContext = createContext(null);

function applyTheme({ mode, accent, brand }) {
  const root = document.documentElement;
  const a = ACCENTS[accent] || ACCENTS.blue;
  // Allow per-hospital brand override
  const primary = brand?.accent_color || a.primary;
  root.style.setProperty("--theme-primary", primary);
  root.style.setProperty("--theme-primary-hover", a.hover);
  root.style.setProperty("--theme-primary-ring", a.ring);
  root.style.setProperty("--theme-primary-soft", a.soft);
  root.style.setProperty("--theme-primary-deep", a.deep);
  if (mode === "dark") {
    document.body.classList.add("dark-mode");
  } else {
    document.body.classList.remove("dark-mode");
  }
}

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem("hk_theme_mode") || "light");
  const [accent, setAccent] = useState(() => localStorage.getItem("hk_theme_accent") || "blue");
  const [brand, setBrand] = useState(null);

  useEffect(() => { applyTheme({ mode, accent, brand }); localStorage.setItem("hk_theme_mode", mode); localStorage.setItem("hk_theme_accent", accent); }, [mode, accent, brand]);

  const value = useMemo(() => ({
    mode, accent, brand,
    setMode, setAccent, setBrand,
    accents: Object.keys(ACCENTS),
  }), [mode, accent, brand]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() { return useContext(ThemeContext); }
